export const CATEGORY_MAPPING = {
  "Cities & Towns": {
    symbol: "city"
  },
  "Cultural & Historic": {
    symbol: "cultural-historic"
  },
  "Beaches & Surf": {
    symbol: "beaches-surf"
  },
  "Attractions": {
    symbol: "generic-attraction"
  },
  "Hikes & Views": {
    symbol: "hiking"
  },
  "National Parks": {
    symbol: "national-park"
  },
  "Scenic Roads": {
    symbol: "scenic-drive"
  },
  "Waterfall": {
    symbol: "waterfalls"
  },
  "Wildlife": {
    symbol: "wildlife" 
  },
  "Hidden Gems": {
    symbol: "hidden-gem" 
  }
};

export function getCategorySymbol(category) {
  const symbol = CATEGORY_MAPPING[category]?.symbol || "attraction";
  return `/icons/${symbol}.png`;
}

export const INITIAL_CENTER = [-85.07909, 9.84913];
export const INITIAL_ZOOM = 2;
export const MIN_ZOOM = 2;
export const MAX_ZOOM = 12;

export const ALL_TYPES = [
  "Attractions",
  "Beaches & Surf",
  "Cities & Towns",
  "Cultural & Historic",
  "Hikes & Views",
  "National Parks",
  "Scenic Roads",
  "Waterfall",
  "Wildlife",
  "Hidden Gems"
];

export const ALL_COUNTRIES = [
  { name: "Argentina", short: "ARG", code: "AR" },
  { name: "Belize", short: "BLZ", code: "BZ" },
  { name: "Bolivia", short: "BOL", code: "BO" },
  { name: "Brazil", short: "BRA", code: "BR" },
  { name: "Canada", short: "CAN", code: "CA" },
  { name: "Chile", short: "CHL", code: "CL" },
  { name: "Colombia", short: "COL", code: "CO" },
  { name: "Costa Rica", short: "CRI", code: "CR" },
  { name: "Ecuador", short: "ECU", code: "EC" },
  { name: "El Salvador", short: "SLV", code: "SV" },
  { name: "Guatemala", short: "GTM", code: "GT" },
  { name: "Honduras", short: "HND", code: "HN" },
  { name: "Mexico", short: "MEX", code: "MX" },
  { name: "Nicaragua", short: "NIC", code: "NI" },
  { name: "Panama", short: "PAN", code: "PA" },
  { name: "Peru", short: "PER", code: "PE" },
  { name: "USA", short: "USA", code: "US" },
  { name: "Uruguay", short: "URY", code: "UY" },
  { name: "Antarctica", short: "ATA", code: "AQ" }
];
